export default [
  {
    path: '/admin/questions',
    name: 'AdminQuestions',
    component: null,
    beforeEnter: (to, from, next) => {
      if (from.name) {
        return
      }
      next({name: 'ErrorNotFound'})
    },
    meta: {
      roles: ['ROLE_ADMIN']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/questions/index.js